import { Box, Skeleton } from "@mui/material";
import React from "react"
import { handlePropsStage } from "./CardTypes/card.style";

type Props = {
  stage: string,
};

const LoadingCard: React.FC<Props> = ({ stage }) => {
  return (
    <Box style={ {...styles.container, borderLeft: `${handlePropsStage(stage)} 4px solid` } }>
      <Skeleton animation="wave" height={24} />
      <Skeleton animation="wave" height={24} sx={{ marginBottom: '8px' }}/>
      <Skeleton animation="wave" height={24} />
      <Skeleton animation="wave" height={24} sx={{ marginBottom: '8px' }}/>
      <Skeleton animation="wave" height={24} />
      <Skeleton animation="wave" height={24} sx={{ marginBottom: '8px' }}/>
      <Skeleton animation="wave" height={24} />
      <Skeleton animation="wave" height={24} sx={{ marginBottom: '8px' }}/>
    </Box>
  )
};

export default LoadingCard;

const styles = {
  container: {
    borderRadius: 5,
    padding: '8px 12px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginBottom: '16px',
  },
}
